import { useMemo } from "react";
import useGetAllActiveQueue from "./queries/useGetAllActiveQueue";
import { findGetParameter } from "@Utils/findGetParameter";

const useAllActiveQueue = ({ keyword = "" }) => {
  const queuesStatus = findGetParameter("queues_status");
  const allActiveQueue = useGetAllActiveQueue();

  const filterByKeyword = (queues, keyword) => {
    if (!keyword) return queues;
    return queues.filter((item) =>
      item?.child?.fullname?.toLowerCase().includes(keyword.toLowerCase()),
    );
  };

  const queues = useMemo(() => {
    let data = allActiveQueue?.data?.queue ?? [];
    data = filterByKeyword(data, keyword);
    return data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allActiveQueue?.data?.queue, keyword, queuesStatus]);

  const sortedQueues = useMemo(() => {
    let data = allActiveQueue?.data?.queues_sorted ?? [];
    data = filterByKeyword(data, keyword);
    return data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allActiveQueue?.data?.queues_sorted, keyword, queuesStatus]);

  return {
    isLoading: allActiveQueue.isLoading,
    data: allActiveQueue,
    queues: sortedQueues
  };
};

export default useAllActiveQueue;
